import { clientRouteConfig } from 'client/shared/routeTargets'
import { TopNavigation } from 'shared/components/TopNavigation'

const topNavigationLinks = [
    {
        label: 'Searches',
        path: clientRouteConfig.searches.path,
    },
    {
        label: 'Mappings',
        path: clientRouteConfig.mappings.path,
    },
] as const

export function ClientTopNavigation() {
    return <TopNavigation links={[...topNavigationLinks]} />
}
